import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('ViewHighlightsButton')(({ theme }) =>
  css({
    mx: ['auto', 'auto', 's'],
    my: ['l', 'l', 'default'],
    display: 'flex',
    width: 'fit-content',
    height: 'auto',
    justifyContent: 'center',
    '&:focus-visible': {
      outline: `${theme.borders[3]} ${theme.colors.aodaFocused}`,
    },
  }),
);

export default themeStyles;
